import { Stack, Text } from "@certn/cascadia";
import {
  Grid,
  GridItem,
  Tabs,
  Tab,
  TabList,
  TabPanel,
} from "@certn/cascadia-react";
import { BrandingPreview } from "./logo-and-icon/preview/BrandingPreview";
import { BrandingUpload } from "./logo-and-icon/upload/BrandingUpload";
import { ColorCustomization } from "./colours/ColorCustomization";
import { Trans } from "react-i18next";
import { useTabState } from "../../../hooks/useTabState";
import { BrandingProvider } from "./logo-and-icon/BrandingContext";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

export function BrandingSettings() {
  const { enableFpCoBrandingV2 } = useFlags();

  const VALID_TAB_IDS = useMemo<readonly string[]>(
    () =>
      enableFpCoBrandingV2 ? ["logo-and-icon", "colours"] : ["logo-and-icon"],
    [enableFpCoBrandingV2]
  );
  const DEFAULT_TAB = "logo-and-icon";

  const { selectedKey, handleSelectionChange } = useTabState({
    validTabs: VALID_TAB_IDS,
    defaultTab: DEFAULT_TAB,
  });

  return (
    <Stack gap="space-6">
      <Text as="h1" style="global/title-large">
        <Trans>Branding</Trans>
      </Text>
      <Text style="global/body-secondary">
        <Trans>
          Upload your company assets to appear in applicant invites and other
          communication for a co-branded experience.
        </Trans>
      </Text>
      <Tabs
        selectedKey={selectedKey}
        onSelectionChange={handleSelectionChange}
        testID="branding-tabs"
      >
        <TabList aria-label="Branding Settings">
          <Tab id="logo-and-icon" testID="logo-and-icon-tab">
            <Trans>Logo and Icon</Trans>
          </Tab>
          {enableFpCoBrandingV2 && (
            <Tab id="colours" testID="colours-tab">
              <Trans>Colors</Trans>
            </Tab>
          )}
        </TabList>
        <TabPanel id="logo-and-icon">
          <BrandingProvider>
            <Grid>
              <GridItem span={[12, 12, 12, 12, 6]}>
                <BrandingUpload />
              </GridItem>
              <GridItem span={[12, 12, 12, 12, 6]}>
                <BrandingPreview />
              </GridItem>
            </Grid>
          </BrandingProvider>
        </TabPanel>
        {enableFpCoBrandingV2 && (
          <TabPanel id="colours">
            <ColorCustomization />
          </TabPanel>
        )}
      </Tabs>
    </Stack>
  );
}
